module.exports = __webpack_public_path__ + "img/anon-avatar.c21f11cf.png";